<template>
  <div>

    <vx-card card-border class="mb-4" title="Dirección de la instalación" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          ¿La dirección del cliente es la misma que la de instalación?
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <div @click="direccionEditable">
            <vs-radio v-model="operacion.direccionClienteIgualInstalacion" vs-name="direccionClienteIgualInstalacion" vs-value="S">Sí</vs-radio>
          </div>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <div @click="direccionEditable">
            <vs-radio v-model="operacion.direccionClienteIgualInstalacion" vs-name="direccionClienteIgualInstalacion" vs-value="N">No</vs-radio>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Dirección *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="DIRECCIÓN" v-validate="'required'" name="direccionInstalacion" 
              v-model="direccionInstalacion.direccion" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.direccion = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('direccionInstalacion')">{{ errors.first('direccionInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span class="campoObligatorio">Núm. *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NÚMERO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/ }" name="numeroInstalacion" 
              v-model="direccionInstalacion.numero" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.numero = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('numeroInstalacion')">{{ errors.first('numeroInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Portal</span>
          </div>
          <div>
            <vs-input class="w-full" name="portal" v-model="direccionInstalacion.portal" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.portal = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Escalera</span>
          </div>
          <div>
            <vs-input class="w-full" name="escalera" v-model="direccionInstalacion.escalera" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.escalera = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span class="campoObligatorio">Planta *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="PLANTA" v-validate="'required'" name="plantaInstalacion" v-model="direccionInstalacion.planta" 
              :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.planta = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('plantaInstalacion')">{{ errors.first('plantaInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Puerta</span>
          </div>
          <div>
            <vs-input class="w-full" name="puerta" v-model="direccionInstalacion.puerta" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.puerta = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Localidad</span>
          </div>
          <div>
            <vs-input class="w-full" name="localidad" v-model="direccionInstalacion.localidad" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.localidad = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Municipio *</span>
          </div>
          <div>
            <select-val-municipio class="w-full" name="municipio" v-model="direccionInstalacion.municipio" :municipioSelected="direccionInstalacion.municipio" 
              :disabled="direccionInstalacionDisabled"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-2/12 w-full">
          <div>
            <span class="campoObligatorio">Cód. Postal *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="CÓD. POSTAL" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 5, max: 5 }" 
              name="cpInstalacion" v-model="direccionInstalacion.cp" :disabled="direccionInstalacionDisabled"/>
            <span class="text-danger text-sm"  v-show="errors.has('cpInstalacion')">{{ errors.first('cpInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-4/12 w-full">
          <div>
            <span class="campoObligatorio">Provincia *</span>
          </div>
          <div>
            <select-val-provincia class="w-full" name="provincia" v-model="direccionInstalacion.provincia" :provinciaSelected="direccionInstalacion.provincia"
              :disabled="direccionInstalacionDisabled"/>
          </div>
        </div>
        <div class="vx-col sm:w-6/12 w-full">
          <div>
            <span>Pais</span>
          </div>
          <div>
            <vs-input class="w-full" name="pais" v-model="direccionInstalacion.pais" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.pais = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import personasStore from '@/store/gestion/personas/index.js'

import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'

export default {
  name: 'OperacionesEditDireccion',
  components: {
    selectValMunicipio,
    selectValProvincia
  },
  data () {
    return {
      operacion: {},
      direccionInstalacion: {},
      direccionInstalacionId: null,
      cliente: {},
      direccionCliente: {},
      direccionClienteId: null,
      direccionInstalacionDisabled: false
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() || this.direccionInstalacion.direccion === null || this.direccionInstalacion.direccion === undefined
        || this.direccionInstalacion.numero === null || this.direccionInstalacion.numero === undefined
        || this.direccionInstalacion.planta === null || this.direccionInstalacion.planta === undefined
        || this.direccionInstalacion.municipio === null || this.direccionInstalacion.municipio === undefined 
        || this.direccionInstalacion.cp === null || this.direccionInstalacion.cp === undefined
        || this.direccionInstalacion.provincia === null || this.direccionInstalacion.provincia === undefined) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    async guardar () {
      if (!this.validateForm) return

      let cambios = false

      // O usuario modificou a pregunda de se a dirección é a mesma que a do cliente, polo tanto actalizamos a operación para asociar o id da dirección do cliente
      // No caso de que a pregunta de se a dirección é a mesma sexa 'S' e os ids coincidan, non é necesario facer nada
      if (this.operacion.direccionClienteIgualInstalacion === 'S' && (this.direccionInstalacionId !== this.direccionClienteId)) {
        cambios = true
        const o = {}
        o.id = this.operacion.id
        o.direccion = `/api/direccions/${this.direccionCliente.id}`
        o.direccionClienteIgualInstalacion = this.operacion.direccionClienteIgualInstalacion
        // Gardamos a operación
        await this.$store.dispatch('operacionesStore/updateOperacion', o)
          .then(() => {})
          .catch((error) => {
            this.showUpdateError(error)
          })
      // Se a dirección non é a mesma que a do cliente pero os ids son iguais, entón é que o usuario cambiou 'S' por 'N' polo que debemos crear unha nova direccion
      // para que non modifique a dirección do cliente e as direccións se traten independentemente
      } else if (this.operacion.direccionClienteIgualInstalacion === 'N' && (this.direccionInstalacionId === this.direccionClienteId)) {
        // crear nova dirección
        // actualizar operacion co id da nova dirección
        cambios = true
        const d = {}
        d.persona = null
        d.direccion = this.direccionInstalacion.direccion
        d.numero = this.direccionInstalacion.numero
        d.portal = this.direccionInstalacion.portal
        d.escalera = this.direccionInstalacion.escalera
        d.planta = this.direccionInstalacion.planta
        d.puerta = this.direccionInstalacion.puerta
        d.localidad = this.direccionInstalacion.localidad
        d.municipio = this.direccionInstalacion.municipio
        d.cp = this.direccionInstalacion.cp
        d.provincia = this.direccionInstalacion.provincia
        d.pais = this.direccionInstalacion.pais
        await this.$store.dispatch('personasStore/addDireccion', d)
          .then((response) => {
            this.direccionInstalacionId = response.data.id
          })
          .catch((error) => {
            this.showUpdateError(error)
            return true
          })

        const o = {}
        o.id = this.operacion.id
        o.direccion = `/api/direccions/${this.direccionInstalacionId}`
        o.direccionClienteIgualInstalacion = this.operacion.direccionClienteIgualInstalacion
        // Gardamos a operación
        await this.$store.dispatch('operacionesStore/updateOperacion', o)
          .then(() => {})
          .catch((error) => {
            this.showUpdateError(error)
          })
      // Se non se modificou a pregunta pero se cambiou algo na dirección, actualizamos a dirección de instalación cos novos datos
      } else if (this.direccionInstalacion.direccion !== this.$store.state.operacionesStore.operacion.direccion.direccion 
                  || this.direccionInstalacion.numero !== this.$store.state.operacionesStore.operacion.direccion.numero
                  || this.direccionInstalacion.portal !== this.$store.state.operacionesStore.operacion.direccion.portal 
                  || this.direccionInstalacion.escalera !== this.$store.state.operacionesStore.operacion.direccion.escalera
                  || this.direccionInstalacion.planta !== this.$store.state.operacionesStore.operacion.direccion.planta 
                  || this.direccionInstalacion.puerta !== this.$store.state.operacionesStore.operacion.direccion.puerta
                  || this.direccionInstalacion.localidad !== this.$store.state.operacionesStore.operacion.direccion.localidad 
                  || this.direccionInstalacion.municipio !== this.$store.state.operacionesStore.operacion.direccion.municipio
                  || this.direccionInstalacion.cp !== this.$store.state.operacionesStore.operacion.direccion.cp 
                  || this.direccionInstalacion.provincia !== this.$store.state.operacionesStore.operacion.direccion.provincia
                  || this.direccionInstalacion.pais !== this.$store.state.operacionesStore.operacion.direccion.pais) {
        
        cambios = true
        await this.$store.dispatch('personasStore/updateDireccion', this.direccionInstalacion)
          .then((response) => {
            this.direccionInstalacionId = response.data.id
          })
          .catch((error) => {
            this.showUpdateError(error)
            return true
          })
      }

      // Se se fixeron cambios actualizamos a operación no State
      if (cambios) {
        await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
          .then((response) => {
            this.operacion = response.data
            this.showUpdateSuccess('DIRECCIÓN ACTUALIZADA', 'Los datos de la dirección de instalación han sido guardados correctamente.')
          })
          .catch((error) => {
            this.showUpdateError(error)
          })
      } else {
        this.showUpdateSuccess('DIRECCIÓN ACTUALIZADA', 'Los datos de la dirección de instalación han sido guardados correctamente.')
      }
    },
    showUpdateSuccess (titulo, texto) {
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showUpdateError (error) {
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    direccionEditable () {
      // Se a dirección de instalación é igual que a do cliente non permitimos que se edite deshabilitando todos os campos e mostramos a dirección do cliente
      if (this.operacion.direccionClienteIgualInstalacion === 'S') {
        this.direccionInstalacion = JSON.parse(JSON.stringify(this.direccionCliente))
        this.direccionInstalacionDisabled = true
      } else {
        this.direccionInstalacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.direccion))
        this.direccionInstalacionDisabled = false
      }
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.direccionInstalacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.direccion))
    this.direccionInstalacionId = this.direccionInstalacion.id
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))
    if (this.cliente.hasOwnProperty('direccion')) this.direccionCliente = JSON.parse(JSON.stringify(this.cliente.direccion))
    if (this.cliente.hasOwnProperty('direccion')) this.direccionClienteId = this.direccionCliente.id
    if (this.operacion.direccionClienteIgualInstalacion === 'S') this.direccionInstalacionDisabled = true
  }
}
</script>

